<template>
  <div>
    <b-modal
      id="modal_form"
      ref="modal_form"
      :title="modal_titulo"
      :ok-title="modal_botao"
      close-title="Fechar"
      v-model="showModal"
      :ok-disabled="form.errors.any()"
      @ok="onStore"
    >
      <form
        @submit.stop.prevent="onStore"
        @keydown="form.errors.clear($event.target.name)"
      >
        <label>Chave CTE</label>
        <b-form-input
          type="text"
          placeholder="Chave CTE"
          v-model="form.chave_cte"
          name="chave_cte"
        ></b-form-input>
        <b-form-feedback
          v-text="form.errors.get('chave_cte')"
          v-if="form.errors.has('chave_cte')"
        ></b-form-feedback>

        <label>Ou </label>

        <label>Chave NFE</label>
        <b-form-input
          type="text"
          placeholder="Chave NFE"
          v-model="form.chave_nfe"
          name="chave_nfe"
        ></b-form-input>
        <b-form-feedback
          v-text="form.errors.get('chave_nfe')"
          v-if="form.errors.has('chave_nfe')"
        ></b-form-feedback>

        <label class="mb-2 d-block text-danger">
          <i class="fa fa-exclamation-triangle"></i>
          Atenção, informar apenas um dos campos acima, onde NFE emitida pelo
          tomador, ou CTE emitido anteriormente.
        </label>

        <b-row>
          <b-col cols="12" md="6">
            <label>Valor CTE</label>
            <b-form-input
              type="text"
              placeholder="Valor CTe"
              v-model="form.vlr_cte"
              name="vlr_cte"
            ></b-form-input>
          </b-col>

          <b-col cols="12" md="6">
            <label>Valor Imposto</label>
            <b-form-input
              type="text"
              placeholder="Valor Imposto"
              v-model="form.vlr_imposto"
              name="vlr_imposto"
            ></b-form-input>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" md="6">
            <label>Valor Aliquota</label>
            <b-form-input
              type="text"
              placeholder="Valor Aliquota"
              v-model="form.vlr_aliquota"
              name="vlr_aliquota"
            ></b-form-input>
          </b-col>

          <b-col cols="12" md="6">
            <label>Tipo do Tomador</label>
            <b-form-radio-group v-model="form.tomador" name="tomador">
              <b-form-radio value="0">Remetente</b-form-radio>
              <b-form-radio value="1">Expedidor</b-form-radio>
              <b-form-radio value="2">Recebedor</b-form-radio>
              <b-form-radio value="3">Destinatário</b-form-radio>
              <b-form-radio value="4">Outros</b-form-radio>
            </b-form-radio-group>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('tomador')"
              v-if="form.errors.has('tomador')"
            ></b-form-feedback>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <label>Observação Fiscal</label>
            <b-form-textarea
              placeholder="Observação Fiscal"
              v-model="form.obs_fiscal"
              name="obs_fiscal"
              rows="4"
              max-rows="8"
            ></b-form-textarea>
          </b-col>
        </b-row>
      </form>
      <div slot="modal-footer" class="w-100">
        <div class="float-left">
          <spinner v-if="loading" message="Gerando..."></spinner>
        </div>
        <div class="float-right">
          <div class="float-left" v-if="this.errors_array.length > 0">
            <b-btn
              class="badge badge-warning"
              @click="showPopover = !showPopover"
              id="popoverButton-sync"
              v-b-tooltip.hover.left="
                'Clique aqui para ver os erros encontrados'
              "
              variant="warning"
              ><i class="fa fa-exclamation-triangle fa-2x"></i
            ></b-btn>

            <b-popover
              :show.sync="showPopover"
              target="popoverButton-sync"
              title="Erros Encontrados"
              data-html="true"
              placement="leftbottom"
            >
              <table class="table" id="mais">
                <tbody>
                  <tr
                    class="bg-gray-light"
                    style="display: table-row"
                    v-for="item in this.errors_array"
                  >
                    <td>
                      {{ item.erro }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-popover>
          </div>
          <b-btn @click="showModal = false" variant="secondary">
            Cancelar
          </b-btn>
          <b-btn
            @click="onStore($event)"
            variant="secondary"
            :disabled="isDisabled"
          >
            Gerar CTE
          </b-btn>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import accounting from "accounting";
export default {
  components: {},
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: "",
  },
  data() {
    return {
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      showModal: false,
      showPopover: false,
      errors_array: [],
      form: new Form({
        chave_cte: "",
        chave_nfe: "",
        tomador: "",
        doc_id: "",
        obs_fiscal: "",
        vlr_cte: "",
        vlr_imposto: "",
        vlr_aliquota: "",
      }),
      helpForm: new Form({ statusRecord: [], params: [], search: "" }),
      fields: [],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  watch: {
    "form.chave_cte"(newVal) {
      if (newVal) this.atualizarObservacaoFiscal();
    },
    "form.chave_nfe"(newVal) {
      if (newVal) this.atualizarObservacaoFiscal();
    },
    "form.vlr_cte"(newVal) {
      this.form.vlr_cte = this.formatCurrencyValue(newVal);
    },
    "form.vlr_imposto"(newVal) {
      this.form.vlr_imposto = this.formatCurrencyValue(newVal);
    },
    "form.vlr_aliquota"(newVal) {
      this.form.vlr_aliquota = this.formatCurrencyValue(newVal);
    },
  },
  methods: {
    onCreate(doc_id, tomador) {
      this.modal_titulo = "Gerar CTE Substituto";
      this.modal_botao = "Gerar CTE";
      this.modal_acao = "i";
      this.isDisabled = false;
      this.form.reset();
      this.errors_array = "";
      this.errors_array = [];
      this.form.doc_id = doc_id;
      this.form.tomador = tomador;
      this.form.obs_fiscal = "Este CTE Substitui o CTE Original com a chave ###";

      this.$refs.modal_form.show();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.form.vlr_cte = this.toFloat(this.form.vlr_cte);
      this.form.vlr_imposto = this.toFloat(this.form.vlr_imposto);
      this.form.vlr_aliquota = this.toFloat(this.form.vlr_aliquota);
      this.form
        .post("/api/cte/substituto/store")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          } else {
            this.$parent.onFilterReset();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({ erro: obj });
                });
              }
            }
          }
        });
    },
    formatCurrencyValue(value) {
      if (!value) return "";
      const numeric = parseFloat(String(value).replace(/\D/g, ""));
      if (isNaN(numeric)) return "";
      return accounting.formatMoney(numeric / 100, "", 2, ".", ",");
    },
    toFloat(value) {
      if (!value) return 0;
      // Substitui vírgula por ponto e remove tudo que não for número ou ponto
      const clean = value.replace(/\./g, "").replace(",", ".");
      return parseFloat(clean) || 0;
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
    atualizarObservacaoFiscal() {
      if (this.form.chave_cte) {
        this.form.obs_fiscal = `Este CTE Substitui o CTE Original com a chave  ${this.form.chave_cte}`;
      } else if (this.form.chave_nfe) {
        this.form.obs_fiscal = `Este CTE Substitui a NFe Original com a chave  ${this.form.chave_nfe}`;
      }
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
    getCurrency: {
      get() {
        return this.$store.getters.currency;
      },
    },
  },
};
</script>
